<nb-card>
    <nb-card-header style="width: 390px; word-wrap: break-word; white-space: normal;">
        <!-- Los siguientes VINS no tienen inspecciones previas -->
          {{ title }}
    </nb-card-header>
    <nb-card-body style="width: 390px;">
        <!-- <angular-slickgrid gridId="gridVinsSinInspec"
        [columnDefinitions]="columnDefinitionsVinsSinInspec"
        [gridOptions]="gridOptionsVinsSinInspec" 
        [dataset]="dataVinsSinInspec" 
        gridHeight="390"
        (onAngularGridCreated)="angularGridReadyVinsSinInspec($event)">
      </angular-slickgrid> -->

            <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="dataVinsSinInspec"
            [columnDefs]="columnDefinitionsVinsSinInspec"
            (gridReady)="onGridReady($event)"
            [enableCellTextSelection]="true" />
    

    </nb-card-body>
    <nb-card-footer>
        <button nbButton size="small" status="primary" class="buttontz" style="width: 21%;" (click)="exportToExcel()">Exportar</button>
        <button nbButton size="small" status="primary" class="buttontz" style="width: 21%; float: right;" (click)="closeDialog()">Cerrar</button>
    </nb-card-footer>
</nb-card>